module.exports = "/shifts/components/calendarHeader/employeeHeaderMonth-cb49e1.html";